var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.transactionDetail"),
            visible: _vm.drawer,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "poId",
                  label: _vm.$t("billingPage.POID"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderId",
                  label: _vm.$t("billingPage.OrderNumber"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "returnOrderId",
                  label: _vm.$t("billingPage.ReturnOrder"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsNumber",
                  label: _vm.$t("CustomerFunction.common.logisticsNo"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: _vm.$t("billingPage.comments"),
                  align: "center",
                  width: "93",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gmtCreate",
                  label: _vm.$t("billingPage.createTime"),
                  align: "center",
                  width: "99",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  label: _vm.$t("billingPage.createdAt"),
                  align: "center",
                  width: "87",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }